import React from "react";
import PropTypes from "prop-types";
import {
  ReactRequiredChildren,
  ReactComponentStaticProps,
} from "../../types/react";

export type ComparisonTableBodyProps = ReactRequiredChildren<
  React.ComponentPropsWithoutRef<"tbody">
>;

export const ComparisonTableBody: ((
  props: ComparisonTableBodyProps
) => JSX.Element) &
  ReactComponentStaticProps<ComparisonTableBodyProps> = ({
  children,
  ...restProps
}) => {
  return <tbody {...restProps}>{children}</tbody>;
};

ComparisonTableBody.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

ComparisonTableBody.displayName = "ComparisonTable.Body";

export default ComparisonTableBody;
